import { render, staticRenderFns } from "./AddressWindow.vue?vue&type=template&id=423d82b4&scoped=true&"
import script from "./AddressWindow.vue?vue&type=script&lang=js&"
export * from "./AddressWindow.vue?vue&type=script&lang=js&"
import style0 from "./AddressWindow.vue?vue&type=style&index=0&id=423d82b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d82b4",
  null
  
)

export default component.exports